import React, { useState, useRef } from 'react';
import { Upload, X, Image as ImageIcon } from 'lucide-react';
import { Button } from './Button';
interface ImageUploadProps {
  label?: string;
  value?: string;
  onChange: (imageUrl: string) => void;
  onRemove?: () => void;
  helperText?: string;
}
export function ImageUpload({
  label,
  value,
  onChange,
  onRemove,
  helperText
}: ImageUploadProps) {
  const [isDragging, setIsDragging] = useState(false);
  const fileInputRef = useRef<HTMLInputElement>(null);
  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      // In a real app, you would upload to a server/CDN
      // For now, create a local object URL for preview
      const imageUrl = URL.createObjectURL(file);
      onChange(imageUrl);
    }
  };
  const handleDragOver = (e: React.DragEvent) => {
    e.preventDefault();
    setIsDragging(true);
  };
  const handleDragLeave = () => {
    setIsDragging(false);
  };
  const handleDrop = (e: React.DragEvent) => {
    e.preventDefault();
    setIsDragging(false);
    const file = e.dataTransfer.files?.[0];
    if (file && file.type.startsWith('image/')) {
      const imageUrl = URL.createObjectURL(file);
      onChange(imageUrl);
    }
  };
  const handleClick = () => {
    fileInputRef.current?.click();
  };
  const handleRemove = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (onRemove) {
      onRemove();
    } else {
      onChange('');
    }
  };
  return <div className="w-full" data-id="element-270">
      {label && <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-271">
          {label}
        </label>}

      {value ? <div className="relative group" data-id="element-272">
          <div className="border-2 border-gray-300 rounded-lg overflow-hidden" data-id="element-273">
            <img src={value} alt="Upload preview" className="w-full h-48 object-cover" data-id="element-274" />
          </div>
          <button onClick={handleRemove} className="absolute top-2 right-2 p-1 bg-red-600 text-white rounded-full opacity-0 group-hover:opacity-100 transition-opacity hover:bg-red-700" data-id="element-275">
            <X className="h-4 w-4" data-id="element-276" />
          </button>
          <Button variant="outline" size="sm" onClick={handleClick} className="mt-2 w-full" data-id="element-277">
            Change Image
          </Button>
        </div> : <div onClick={handleClick} onDragOver={handleDragOver} onDragLeave={handleDragLeave} onDrop={handleDrop} className={`
            border-2 border-dashed rounded-lg p-8 text-center cursor-pointer transition-colors
            ${isDragging ? 'border-red-500 bg-red-50' : 'border-gray-300 hover:border-gray-400 bg-white'}
          `} data-id="element-278">
          <Upload className="h-10 w-10 text-gray-400 mx-auto mb-3" data-id="element-279" />
          <p className="text-sm text-gray-600 mb-1" data-id="element-280">
            Click to upload or drag and drop
          </p>
          <p className="text-xs text-gray-500" data-id="element-281">PNG, JPG up to 10MB</p>
        </div>}

      <input ref={fileInputRef} type="file" accept="image/*" onChange={handleFileChange} className="hidden" data-id="element-282" />

      {helperText && <p className="mt-1 text-xs text-gray-500" data-id="element-283">{helperText}</p>}
    </div>;
}